import { connect } from 'react-redux';

import ExerciseExecuteCode from '../components/Exercise/ExerciseExecuteCode';
import { isExamExercise } from '../helpers/examUtilities';
import * as actions from '../redux/actions';
import * as selectors from '../redux/selectors';

const mapStateToProps = (state: any) => {
  const exerciseType = selectors.selectExercise(state).get('type');

  return {
    isReady: selectors.isSessionReady(state),
    isBusy: selectors.isSessionBusy(state),
    isCompletedOverlayShown: selectors
      .selectUserExercise(state)
      .getIn(['completed', 'show'], false),
    nbAttempts: isExamExercise(exerciseType)
      ? selectors.selectNbAttempts(state)
      : undefined,
    isLightTheme: selectors.selectIsLightTheme(state),
    userId: selectors.selectUserSettings(state).get('id'),
    explainCodeButtonEnabled: selectors.selectExplainCodeButtonEnabled(state),
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  epicResetCode: () => dispatch(actions.epicResetCode()),
});

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ExerciseExecuteCode);
